import Slider from './Inputs/Slider';
import Text from './Inputs/Text';
import Checkbox from './Inputs/Checkbox';
import Radio from './Inputs/Radio';
import Select from './Inputs/Select';
import Select2 from './Inputs/Select2';
import Date from './Inputs/Date';
import DateRange from './Inputs/DateRange';
import ICheck from './Inputs/ICheck';
import DateTime from './Inputs/DateTime';
import ImportWrapper from './Inputs/InputWrapper';

// const Slider = import(/* webpackChunkName: "inputs.slider" */ './Inputs/Slider');
// const Text = import(/* webpackChunkName: "inputs.text" */ './Inputs/Text');
// const Checkbox = import(/* webpackChunkName: "inputs.checkbox" */ './Inputs/Checkbox');
// const Radio = import(/* webpackChunkName: "inputs.radio" */ './Inputs/Radio');
// const Select = import(/* webpackChunkName: "inputs.select" */ './Inputs/Select');
// const Select2 = import(/* webpackChunkName: "inputs.select2" */ './Inputs/Select2');
// const DateRange = import(/* webpackChunkName: "inputs.daterange" */ './Inputs/DateRange');
// const ICheck = import(/* webpackChunkName: "inputs.icheck" */ './Inputs/ICheck');

export {
  Slider,
  Text,
  Checkbox,
  Radio,
  Select,
  Select2,
  Date,
  DateRange,
  ICheck,
  DateTime,
  ImportWrapper,
};
